import React from "react";
import { SvgCommon } from ".";
import { IconModel } from "../../models";

export const BranchIcon: React.FC<IconModel> = (props) => {
  return (
    <SvgCommon {...props}>
      <path d="M11 2L3 8V20H8.5V16.5C8.5 15.1193 9.61929 14 11 14V14C12.3807 14 13.5 15.1193 13.5 16.5V20H19V8L11 2ZM11 2L1 9.5M11 2L21 9.5" stroke={props.color} strokeWidth="2" strokeLinecap="round"/>
      <circle cx="11" cy="9" r="2" stroke={props.color} strokeWidth="2"/>
    </SvgCommon>
  );
};